import { AUTH_API_BASE_URL } from '../constants/AuthConstants';
import { JSON_CONTENT_TYPE } from '../constants/ApiConstants';

export type ApiErrorBody = {
  error?: string;
  message?: string;
};

type JsonRequestOptions = Omit<RequestInit, 'body'> & {
  payload?: unknown;
};

export function buildApiUrl(path: string) {
  return `${AUTH_API_BASE_URL}${path}`;
}

export async function parseJsonResponse<TResponse>(
  response: Response,
): Promise<(TResponse & ApiErrorBody) | undefined> {
  const responseText = await response.text();
  return responseText ? (JSON.parse(responseText) as TResponse & ApiErrorBody) : undefined;
}

export async function requestJson<TResponse>(
  url: string,
  options: JsonRequestOptions = {},
): Promise<{ response: Response; body: (TResponse & ApiErrorBody) | undefined }> {
  const { payload, headers, ...rest } = options;
  const response = await fetch(url, {
    ...rest,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      ...(headers ?? {}),
    },
    body: payload === undefined ? undefined : JSON.stringify(payload),
  });

  const body = await parseJsonResponse<TResponse>(response);
  return { response, body };
}

export async function uploadFileToPresignedUrl(
  uploadUrl: string,
  headers: Record<string, string>,
  file: Blob,
  errorMessage: string,
) {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers,
    body: file,
  });

  if (!response.ok) {
    throw new Error(errorMessage);
  }
}
